import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 95%;
  overflow-x: auto;
  /* border: 1px solid red; */

`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid red; */

`;

export const StyledTableHead = styled.thead`
  /* margin-bottom: 16px; */
  color: var(--Dark-Verde---dark, #70AC17);
  font-family: Roboto;
  font-size: 16px;
  font-weight: 900;
  line-height: 24px;
  /* border: 1px solid red; */

`;

export const StyledTableBody = styled.tbody`
  /* tr:last-child td {
    border-bottom: 2px solid #70AC17; 
  } */
`;


export const StyledTableRow = styled.tr`
  background-color: #ffffff;
  margin-bottom: 16px;
  color: var(#222222);
  font-family: sans-serif;
  font-size: 14px;
  /* border: 1px solid red; */

`;

export const StyledTableCell = styled.td`
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  /* border: 1px solid red; */

`;



export const StyledTableBenef = styled.span`
  color: #F26A1D;
  border: 1px solid red;

`;

export const StyledTableHeaderCell = styled.th`
  border-bottom: 2px solid #fff;
  text-align: left;
  padding: 8px;
  width: 35%;
  /* border: 1px solid red; */

`;

export const ButtonsContainer = styled.div`
  display: flex;
  /* justify-content: center;
  align-items: center; */
  /* border: 1px solid red; */
`;